// import React, { useEffect, useState } from 'react'
// import ReactECharts from "echarts-for-react";
// import { APIConstants } from '../../../Common/APIConstants';
// import { adjustTimeByFiveHoursThirtyMinutes } from '../../../Utils/DateConverstion';
// import dayjs from 'dayjs';
// import { getAdjustedDate } from '../CommonFunctions';
// import { useStoreUpdaterWithAPI } from '../../../Hooks/UseStoreUpdaterWithApi';
// import { Card } from 'antd';


// const SMMLSECBarChart = ({theme,cardStyle}) => {

//     const { makeRequest } = useStoreUpdaterWithAPI();
//       const correctDate = new Date(getAdjustedDate());
//       const defaultToDate = dayjs(correctDate).hour(6).minute(30).second(0);
//       const defaultFromDate = dayjs(correctDate)
//         .subtract(30, "days")
//         .hour(6)
//         .minute(30)
//         .second(0);
//       const [toDate, setToDate] = useState(defaultToDate);
//       const [fromDate, setFromDate] = useState(defaultFromDate);
//       const [loading, setLoading] = useState(true); // New loading state
//       const [data, setData] = useState([]);
//       const [pieData2, setPieData2] = useState([]);


// const formatEChartsBarOption = (responseData) => {
//   // Extract unique dates for the x-axis
//   const uniqueDates = [...new Set(responseData.map(item => dayjs(item.createdOn).format("YYYY-MM-DD")))];

//   // Group data by meterName
//   const meterGroups = {};
//   responseData.forEach(item => {
//     if (!meterGroups[item.groupName]) {
//       meterGroups[item.groupName] = {};
//     }
//     meterGroups[item.groupName][dayjs(item.createdOn).format("YYYY-MM-DD")] = item.groupConsumption;
//   });

//   // Create dynamic series
//   const series = Object.keys(meterGroups).map(groupName => ({
//     name: groupName, // Meter name as legend
//     type: "bar",
//     data: uniqueDates.map(date => meterGroups[groupName][date] || 0), // Fill missing dates with 0
//   }));

//   return {
//     uniqueDates,
//     series,
//     // legend: {
//     //   top: "top",
//     // },
//     // xAxis: {
//     //   type: "category",
//     //   data: uniqueDates, // X-axis: Unique Dates
//     // },
//     // yAxis: { type: "value" },
//     // series, // Dynamically generated series
//   };
// };

//       const getReposnse = async () => {
//         // setLoading(true)
//         const currentDate = new Date();
    
//         // const { from, to } = calculateDateRangeFromDate(currentDate, 15, 15);
    
//         const inputData = {
//           // ConverterID: Number(lgConvId),
//           // MeterIds: ids,
//           FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
//           ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
//         };
//         console.log("getReposnse");
//         console.log(inputData.ToDate, inputData.FromDate);
    
//         try {
//           const res = await makeRequest({
//             type: APIConstants.GET,
//             url: `${APIConstants.SMML_SEC_STATISTICS_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
//           });
//           console.log(res);
//           if (res && res.length > 0) {
//             const response = formatEChartsBarOption(res)
//             console.log(response)
//             setData(res);
//             setPieData2(res[1]);
//           }
//         } catch (error) {
//           console.log(error);
//         } finally {
//           setLoading(false); // Stop loading
//         }
//       };
    
//       useEffect(() => {
//         getReposnse();
//       }, []);
//     const barOption = {
//         legend: {
//           top: "top", // Places legend at the top
//         },
//         xAxis: {
//           type: "category",
//           data: data?.uniqueDates
//         },
//         yAxis: { type: "value" },
//         series: data?.series
//         // [
//         //   { name: "Target", type: "bar", data: [320, 332, 301, 334] },
//         //   { name: "YTD Actual", type: "bar", data: [150, 182, 191, 234] },
//         // ],
//       };
//   return (
//     <div className="  w-3/5">
//       <Card title="SMMIL SEC Statistics" className="" style={cardStyle}>
//           <ReactECharts option={barOption} />
//         </Card>
//   </div>
//   )
// }

// export default SMMLSECBarChart



import React, { useEffect, useState, useRef } from "react";
import ReactECharts from "echarts-for-react";
import { APIConstants } from "../../../Common/APIConstants";
import { adjustTimeByFiveHoursThirtyMinutes } from "../../../Utils/DateConverstion";
import dayjs from "dayjs";
import { getAdjustedDate } from "../CommonFunctions";
import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
import { Card } from "antd";

const SMMLSECBarChart = ({ theme, cardStyle }) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const correctDate = new Date(getAdjustedDate());
  const defaultFromDate =  dayjs(correctDate).subtract(1, "day").startOf("day"); 
  const defaultToDate =  dayjs(correctDate).startOf("day");
  
  const [toDate, setToDate] = useState(defaultToDate);
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState({ uniqueDates: [], series: [] });

  const chartRef = useRef(null);


const transformDataForECharts = (data) => {
  const xAxisData = data.map(item => item.subGroupName);
  console.log(data)

  const numericalKeys = Object.keys(data[0]).filter(
    key => !['groupName', 'groupID', 'subGroupName', 'subGroupID', 'fromDate', 'toDate'].includes(key)
  );

  const series = numericalKeys.map(key => ({
    name: key==='daySubGroupConsumption'?'Daily ':key==='mtdSubGroupConsumption'?'MTD ':'Target',
    type: 'bar',
    data: data.map(item => item[key])
  }));

  return { xAxisData, series };
};
 





const getResponse = async () => {
  setLoading(true);
  const inputData = {
    FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
    ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
  };
  
  try {
    const res = await makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.SMML_SEC_STATISTICS_CONSUMPTION}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
    });
    console.log(res)
    console.log(transformDataForECharts(res)); 
 

      if (res && res.length > 0) {
        const response = transformDataForECharts(res);
        console.log(response)
        setChartData(response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getResponse();
  }, []);
  
  const darkMode = theme === "dark";

  const barOption = {
    backgroundColor: darkMode ? "" : "#ECFDF3", // Background color
    textStyle: {
      color: darkMode ? "#E0E0E0" : "#333333", // Text color
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      backgroundColor: darkMode ? "#333" : "#FFF",
      textStyle: { color: darkMode ? "#E0E0E0" : "#333" },
    },
    legend: {
      textStyle: { color: darkMode ? "#E0E0E0" : "#333" },
    },
    xAxis: {
      type: "category",
      data: chartData?.xAxisData,
      axisLabel: { color: darkMode ? "#E0E0E0" : "#333" },
      axisLine: { lineStyle: { color: darkMode ? "#E0E0E0" : "#333" } },
    },
    yAxis: {
      type: "value",
      axisLabel: { color: darkMode ? "#E0E0E0" : "#333" },
      axisLine: { lineStyle: { color: darkMode ? "#E0E0E0" : "#333" } },
    },
    grid: { left: "5%", right: "5%", bottom: "10%", containLabel: true },
    series: chartData.series.map((item) => ({
      ...item,
    })),
  };
  console.log(barOption)

  return (
    <div className="w-3/5 h-[350px] text-left">
      <Card  style={cardStyle}
      className={`${theme==='dark'?'bg-transparent':'text-black bg-[#ECFDF3]'}`}
       title={
        <span className={`${theme==='dark'?'text-white':'text-black'}` }>SMML SEC Statistics</span>
      } 
      >
        <ReactECharts ref={chartRef} option={barOption} />
      </Card>
    </div>
  );
};

export default SMMLSECBarChart;




